
<div class="traveller hoverarea" (click)="hasApis ? showDetails = !showDetails : null">
    <div class="excerpt traveller-part">

        <div class="part">
            <!-- Traveller's name && type -->
            <div class="traveller-review">
                <div>

                    <strong class="title-lastName-firstName"> {{t_title[travellerItem.title]}}
                        {{travellerItem?.lastName}} {{travellerItem?.firstName}}</strong>
                    <span class="type"> {{typeCode[travellerItem.type]}}</span>
                </div>
                <div [class.hoverPopInfo]="!hasApis || (hasApis && message && message != '')" class="details-icon">
                    <fa-icon [icon]="iconPen" class="hovervisible" (click)="showForm(travellerKey)" click-stop *ngIf="editable"></fa-icon>
                    <fa-icon [icon]="showDetails ? iconEyeSlash : iconEye" *ngIf="hasApis"></fa-icon>
                    <btn *ngIf="useApis && (!hasApis || (hasApis && message && message != ''))" type="warning">
                          <span class="icon">
                              <fa-icon [icon]="iconExclamation"></fa-icon>
                          </span>
                    </btn>
                    <div class="small-text center" [innerHTML]="message" *ngIf="message != ''" [class.popInfoSmall]="!hasApis" [class.popInfoBig]="hasApis"></div>
                </div>
            </div>

        </div>

    </div>

    <div class="alert traveller-part"  *ngIf="message">
        <message type="warning" fullwidth="true" [value]="message"></message>
    </div>

    <div class="details" [class.showDetails]="showDetails" *ngIf="hasApis">
        <div class=" ctn ctn-left ctn-wrap">

            <div class="item-sep" *ngIf="travellerItem.birthDate">
                <span class="label">{{t_nele}}</span>
                <strong>{{travellerItem.birthDate | dateMoment: dateFormat.momentShort}}</strong>
            </div>

            <div class="item-sep" *ngIf="travellerItem.givenNames">
                <span class="label">{{t_autresprenoms}}</span>
                <strong *ngFor="let names of travellerItem.givenNames; let l = last">{{names}}<ng-container *ngIf="!l">, </ng-container></strong>
            </div>

            <div class="item-sep" *ngIf="travellerItem.citizenship">
                <span class="label">{{t_nationalite}}</span>
                <strong>{{travellerItem.citizenship}}</strong>
            </div>

            <ng-container *ngIf="travellerItem.passport">
                <div class="item-sep" [class.showDetails]="showDetails">
                    <span class="label">{{t_passeport}}</span>
                    <strong>{{travellerItem.passport.number}}</strong>
                </div>
                <div class="item-sep" *ngIf="travellerItem.passport.issuance && travellerItem.passport.issuance.country">
                    <span class="label">{{Yii.t('wui-shared-js', 'Pays d\'émission')}}</span>
                    <strong>{{travellerItem.passport.issuance.country}}</strong>
                </div>
                <div class="item-sep" *ngIf="travellerItem.passport.validity && travellerItem.passport.validity.end">
                    <span class="label">{{t_expirele}}</span>
                    <strong>{{travellerItem.passport.validity.end | dateMoment: dateFormat.momentShort}}</strong>
                </div>

            </ng-container>

            <ng-container *ngIf="travellerItem.identityCard">
                <div class="item-sep" [class.showDetails]="showDetails">
                    <span class="label">{{Yii.t('wui-shared-js',"Carte d'identité")}}</span>
                    <strong>{{travellerItem.identityCard.number}}</strong>
                </div>
                <div class="item-sep" *ngIf="travellerItem.identityCard.issuance && travellerItem.identityCard.issuance.country">
                    <span class="label">{{Yii.t('wui-shared-js', 'Pays d\'émission')}}</span>
                    <strong>{{travellerItem.identityCard.issuance.country}}</strong>
                </div>
                <div class="item-sep" *ngIf="travellerItem.identityCard.validity && travellerItem.identityCard.validity.end">
                    <span class="label">{{t_expirele}}</span>
                    <strong>{{travellerItem.identityCard.validity.end | dateMoment: dateFormat.momentShort}}</strong>
                </div>

            </ng-container>


        </div>




    </div>
    <div>
